import  { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { fieldsToRemoveFromOrderItems } from './enums';

export const formatNumberToCurrency = (number) => {
  const numberWithCommas = Number(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedNumber = `$${numberWithCommas}`;
  return formattedNumber;
};

export const currencyFormat = (number) => {
  const numberWithCommas = ((Math.trunc(number*100)/100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const formattedNumber = `$ ${numberWithCommas}`;
  return formattedNumber;
};

export const formatDate = (date) => {
  return moment(date).format('DD/MM/YY');
};

export function truncateString(str, limit) {
  if (limit > 3){
    limit = limit-3
  }
  if (str.length > limit) {
    return str.substring(0, limit) + '...';
  }
  return str;
}

export function truncateDecimal(number) {
  return Number(Number(number).toFixed(2));
}

export const delay = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function getElementByPath(path, processedJson, originalJson) {
  const targetCharacteristics = [];

  for (let i = 0; i < path.length; i++) {
    const index = path[i];
    

    if (processedJson && processedJson.length > index) {
      const currentNode = processedJson[index];
      targetCharacteristics.push({
        characteristicName: currentNode.characteristicName,
        value: currentNode.value,
      });
      processedJson = currentNode.children;
    } else {
      console.error(`Invalid path at index ${i}. Path does not exist.`);
      return null;
    }
  }

  const elementInOriginalJson = findElementByCharacteristics(originalJson, targetCharacteristics);

  return elementInOriginalJson;
}

export function findElementByCharacteristics(json, targetCharacteristics) {
  for (let i = 0; i < json.length; i++) {
    const product = json[i].characteristics;

    if (areCharacteristicsEqual(product, targetCharacteristics)) {
      return json[i];
    }
  }
  return null;
}

function areCharacteristicsEqual(productCharacteristics, targetCharacteristics) {
  if (productCharacteristics.length !== targetCharacteristics.length) {
    return false;
  }

  for (let i = 0; i < productCharacteristics.length; i++) {
    const productCharacteristic = productCharacteristics[i];
    const targetCharacteristic = targetCharacteristics[i];

    if (
      productCharacteristic.characteristicName !== targetCharacteristic.characteristicName ||
      productCharacteristic.value !== targetCharacteristic.value
    ) {
      return false;
    }
  }

  return true;
}

export function sumExtraPrice(json) {
  // console.log("JSON", json);
  let totalExtraPrice = 0;

  if (json && json.characteristics && Array.isArray(json.characteristics)) {
    // console.log("IS JSON", json.characteristics);
    json.characteristics.forEach((characteristic) => {
      const extraPrice = parseFloat(characteristic.extraPrice);
      if (!isNaN(extraPrice)) {
        totalExtraPrice += extraPrice;
      }
    });
  }

  return totalExtraPrice;
}

const safeNumParse = (value) => {
  return isNaN(parseFloat(value)) ? 0 : parseFloat(value);
};

export const sumExtraDimensions = (characteristics) => {
  // console.log("CHARS", characteristics);
  let totalWeightExtra = 0;
  let totalHeightExtra = 0;
  let totalWidthExtra = 0;
  let totalLongitudeExtra = 0;

  if (Array.isArray(characteristics)) {
    // console.log("IS ARRAY");

    characteristics.forEach((characteristic) => {
      totalWeightExtra += safeNumParse(characteristic.weightModifier || 0);
      totalHeightExtra += safeNumParse(characteristic.heightModifier || 0);
      totalWidthExtra += safeNumParse(characteristic.widthModifier || 0);
      totalLongitudeExtra += safeNumParse(characteristic.longitudeModifier || 0);
    });
  }

  return {
    totalWeightExtra,
    totalHeightExtra,
    totalWidthExtra,
    totalLongitudeExtra
  };
}

export const checkValueStock = (characteristcics) => {
  // Check if any value has stock 0 and return greatest extra delivery time
  let noStock = false;
  let extraDeliveryTime = 0;

  if (Array.isArray(characteristcics)) {
    characteristcics.forEach((characteristic) => {
      if (characteristic.stock === 0) {
        noStock = true;
        extraDeliveryTime = Math.max(extraDeliveryTime, characteristic.extraDeliveryTime);
      }
    });
  }

  return { noStock, extraDeliveryTime };
}

export const getBasePrice = (product, dollarPrice=0) => {
  // console.log("PRODUCT", product);
  // console.log("DOLLAR PRICE", dollarPrice);
  // console.log("PRODUCT VARIANTS", product.productVariants);
  
  const productPrice = truncateDecimal(Number(product.price) * Number(dollarPrice));
  const totalExtraPrice = truncateDecimal(sumExtraPrice(product.productVariants[0]) * dollarPrice);
  return truncateDecimal(totalExtraPrice + productPrice);
}


export const addItemToCart = (product) => {
  const cartData = JSON.parse(localStorage.getItem('userCart')) || null;
  let newCart = null;
  if(!cartData){
    const userId = localStorage.getItem('UID') || '';
    const cartItem = getCartItem(product);
    newCart = { userId: userId, items: [cartItem]}
  }else{
    const skuProduct = !!product.productVariants.length ? product.productVariants[0].sku : product.code;
    const productIndex = cartData.items.findIndex(item => item.sku === skuProduct)
    if(productIndex >= 0){
        cartData.items[productIndex].quantity += 1;
        newCart = cartData;
    }else{
      const cartItem = getCartItem(product);
      cartData.items.push(cartItem);
      newCart = cartData;
    }
  }
  return newCart;
}

export const getCount = (cart) => {
  return cart ? cart.items.reduce((total, item) => total + Number(item.quantity), 0) : 0;
}

export const getCartItem = (product) => {
  return { 
    product: product, 
    sku: !!product.productVariants.length ? product.productVariants[0].sku : product.code,
     quantity: 1 
  }
}

export const cleanupProduct = (product) => {
  const cleaned = { ...product };
  fieldsToRemoveFromOrderItems.forEach(field => delete cleaned[field]);
  return cleaned;
};

// Function to remove unnecessary product data from items in cart
export const cleanupCartItems = (products) => {
  // Handle both single product object and array
  const itemsArray = Array.isArray(products) ? products : [products];
  
  return itemsArray.map(item => {
    return cleanupProduct(item);
  });
}

// Util functions to calculate customized product prices and dimensions based on their variantMatrix and applied dependency rules

// Build the price matrix based on the variant matrix and base characteristics
export const buildPriceMatrixMap = (variantMatrix, baseCharacteristics) => {
  const map = new Map();

  variantMatrix?.forEach(entry => {
      const primaryKey = entry.primaryValueCode;

      // Transform characteristics into a nested lookup
      const characteristics = {};
      (entry.characteristics || []).forEach(char => {

          const baseChar = baseCharacteristics.find(c => c.characteristicId === char.characteristicId);
          if (!baseChar) return;

          characteristics[char.characteristicId] = {
              characteristicName: char.characteristicName,
              values: char.values.reduce((acc, val) => {

                  const baseVal = baseChar.values.find(v => v.code === val.code);
                  if (!baseVal) return;

                  acc[val.code] = {
                      valueName: val.valueName,
                      enabled: val.enabled,
                      extraPrice: Number(val.price_modifier) || 0,
                      weightModifier: Number(val.weight_modifier) || 0,
                      heightModifier: Number(val.height) || 0,
                      longitudeModifier: Number(val.depth) || 0,
                      widthModifier: Number(val.width) || 0,
                      stock: Number(baseVal.stock) || 0,
                      extraDeliveryTime: Number(baseVal.extraDeliveryTime) || 0,
                  };

                  // console.log("ACC", acc);
                  return acc;
              }, {})
          };

          // console.log("TRANSFORMED CHARACTERISTIC", characteristics[char.characteristicId]);
      });

      // console.log("ENTRIES", entry);

      // Store in map 
      map.set(primaryKey, {
          base: {
              extraPrice: Number(entry.price_modifier) || 0,
              weightModifier: Number(entry.weight_modifier) || 0,
              widthModifier: Number(entry.width) || 0,
              heightModifier: Number(entry.height) || 0,
              longitudeModifier: Number(entry.depth) || 0,
              stock: Number(entry.stock) || 0,
              extraDeliveryTime: Number(entry.extraDeliveryTime) || 0,
          },
          ...characteristics
      });
  });

  return map;
}


// Get the selected map for the custom variant
export const getSelectedMap = (currCustomVariant) => {
  const selectedMap = new Map();
  currCustomVariant.characteristics.forEach(c => {
      if (c.valueName) {
          selectedMap.set(c.characteristicId, c.valueName);
      }
  });
  return selectedMap || new Map();
}


// Check if the custom product has a primary value assigned
export const checkPrimarySelected = (customProduct) => {
  const primarySelected = customProduct.characteristics?.find(c => c.primary);
  return primarySelected?.code;
}


// Set base prices for the characteristics
export const setBasePrices = ({characteristics, updatedCustomProduct, priceMatrixMap}) => {
  const primarySelected = updatedCustomProduct.characteristics?.find(c => c.primary && c.valueName).code;
  if (!primarySelected) return characteristics;

  const primaryChar = checkPrimarySelected(updatedCustomProduct);
  if (!primaryChar) return characteristics;

  const primaryEntry = priceMatrixMap.get(primaryChar);
  if (!primaryEntry) return characteristics;

  // console.log("SETTING BASE PRICES", primaryEntry, characteristics);

  const updatedCharacteristics = characteristics.map(c => {
      if (c.primary) {
          // console.log("PRIMARY CHARACTERISTIC", c);
          // Primary characteristic: no values to map, just set base directly
          const base = primaryEntry.base || {};
          return {
              ...c,
              extraPrice: base.extraPrice ?? 0,
              weightModifier: base.weightModifier ?? 0,
              heightModifier: base.heightModifier ?? 0,
              widthModifier: base.widthModifier ?? 0,
              longitudeModifier: base.longitudeModifier ?? 0,
              stock: base.stock ?? 0,
              extraDeliveryTime: base.extraDeliveryTime ?? 0,
          };
      } else {
          // console.log("NON-PRIMARY CHARACTERISTIC", c);
          // Non-primary: apply modifiers from priceMatrix entry
          const charData = primaryEntry[c.characteristicId];
          // console.log("NON-PRIMARY CHAR DATA", charData);

          if (!charData) return c;

          return {
              ...c,
              values: Object.entries(charData.values).filter(([code, val]) => val.enabled).map(([code, v]) => {
                  const valData = charData.values[code] || {};

                  // console.log("NON-PRIMARY VAL DATA", valData);
                  return {
                      ...v,
                      code: code,
                      valueName: v.valueName,
                      extraPrice: valData.extraPrice ?? 0,
                      weightModifier: valData.weightModifier ?? 0,
                      heightModifier: valData.heightModifier ?? 0,
                      widthModifier: valData.widthModifier ?? 0,
                      longitudeModifier: valData.longitudeModifier ?? 0,
                      stock: valData.stock ?? 0,
                      extraDeliveryTime: valData.extraDeliveryTime ?? 0,
                  };
              })
          };
      }
  });

  // console.log("UPDATED CHARACTERISTICS", updatedCharacteristics);

  return updatedCharacteristics;
};

// Apply dependency rules to custom product characteristics
export const setAppliedDependencyRules = ({characteristics, dependencyRules, currCustomVariant, priceMatrixMap, selectedMap}) => {
  const primaryChar = currCustomVariant.characteristics.find(c => c.primary);
  const primaryEntry = priceMatrixMap.get(primaryChar?.code);
  const selectedPrimaryValueName = primaryChar?.valueName;

  const updatedCharacteristics = characteristics.map(c => ({
      ...c,
      values: c.values.map(v => ({ ...v }))
  }));

  for (const rule of dependencyRules) {
    // Check if rule applies based on primary characteristic
    // If rule.primary is empty or undefined, the rule applies to all primary values
    // Otherwise, the selected primary value must be in the rule.primary array
    const primaryMatches = !rule.primary?.length || rule.primary.includes(selectedPrimaryValueName);
    if (!primaryMatches) continue;

    // Check if rule applies based on selectedMap (the "if" conditions)
    const applies = (rule.if || []).every(cond => {
        const chosen = selectedMap.get(cond.characteristicId);
        return chosen && cond.values.includes(chosen);
    });

    if (!applies) continue;

    for (const thenTarget of rule.then || []) {
      const char = updatedCharacteristics.find(c => c.characteristicId === thenTarget.characteristicId);
      if (!char) continue;

      // Build a whitelist of allowed value names
      const allowedValues = new Set((thenTarget.values || []).map(v => v.valueName || v));

      // console.log("ALLOWED VALUES", allowedValues);

      // console.log("FILTERING OPTIONS");
      char.values = char.values.filter(v => allowedValues.has(v.valueName));

      // console.log("Remove not allowed values from currCustomVariant");
      
      // 🔑 Remove any blocked values only from the affected characteristic
      const variantChar = currCustomVariant.characteristics.find(
        c => c.characteristicId === thenTarget.characteristicId
      );

      if (variantChar && !allowedValues.has(variantChar.valueName)) {
        // console.log("REMOVING VALUE", variantChar.valueName);

        variantChar.valueName = '';
        variantChar.code = '';
        variantChar.extraPrice = 0;
        variantChar.weightModifier = 0;
        variantChar.heightModifier = 0;
        variantChar.widthModifier = 0;
        variantChar.longitudeModifier = 0;
        variantChar.stock = 0;
        variantChar.extraDeliveryTime = 0;
      }

      char.values = char.values.map(v => {
        // Find matching rule data
        const matchedRuleValue = (thenTarget.values || []).find(rv => rv.valueName === v.valueName);
        const baseValueData = primaryEntry?.[char.characteristicId]?.values[v.code] || {};

        return {
            ...v,
            code: v.code,
            valueName: v.valueName,
            extraPrice: 
                (baseValueData.extraPrice ?? v.extraPrice ?? 0) + 
                (matchedRuleValue?.price_modifier ?? 0),
            weightModifier: 
                (baseValueData.weightModifier ?? v.weightModifier ?? 0) + 
                (matchedRuleValue?.weight_modifier ?? 0),
            heightModifier: 
                (baseValueData.heightModifier ?? v.heightModifier ?? 0) + 
                (matchedRuleValue?.height ?? 0),
            widthModifier: 
                (baseValueData.widthModifier ?? v.widthModifier ?? 0) + 
                (matchedRuleValue?.width ?? 0),
            longitudeModifier: 
                (baseValueData.longitudeModifier ?? v.longitudeModifier ?? 0) + 
                (matchedRuleValue?.depth ?? 0),
            stock: matchedRuleValue?.stock ?? baseValueData.stock ?? v.stock ?? 0,
            extraDeliveryTime: matchedRuleValue?.extraDeliveryTime ?? baseValueData.extraDeliveryTime ?? v.extraDeliveryTime ?? 0
        };
      });
    }
  }

  return updatedCharacteristics;
}

// Update prices in the customVariant to match those in the characteristicListData
export const setCustomBasePrices = ({characteristics, variant, priceMatrixMap}) => {
  if (!variant?.characteristics || !characteristics || !priceMatrixMap) return variant;

  const primaryCode = variant.characteristics.find(c => c.primary)?.code;
  if (!primaryCode) return variant;

  const primaryEntry = priceMatrixMap.get(primaryCode);
  if (!primaryEntry) return variant;

  // console.log("PRIMARY CHARACTERISTIC", primaryEntry);

  return {
      ...variant,
      characteristics: variant.characteristics.map(c => {
          // console.log("CUSTOM VARIANT CHARACTERISTIC", c);

          if (c.primary) {
              const base = primaryEntry.base || {};
              // console.log("PRIMARY CHARACTERISTIC", c, base);
              return {
                  ...c,
                  extraPrice: base.extraPrice ?? 0,
                  weightModifier: base.weightModifier ?? 0,
                  heightModifier: base.heightModifier ?? 0,
                  widthModifier: base.widthModifier ?? 0,
                  longitudeModifier: base.longitudeModifier ?? 0,
                  stock: base.stock ?? 0,
                  extraDeliveryTime: base.extraDeliveryTime ?? 0,
              };
          } else {
              const charData = characteristics.find(charItem => charItem.characteristicId === c.characteristicId);

              // console.log("CHARACTERISTIC", charData);
              if (!charData.values) return c;

              // Find selected value
              const selectedValue = charData.values?.find(v => v.code === c.code) || {};
              // console.log("SELECTED VALUE", selectedValue);
              return {
                  ...c,
                  extraPrice: selectedValue.extraPrice ?? 0,
                  weightModifier: selectedValue.weightModifier ?? 0,
                  heightModifier: selectedValue.heightModifier ?? 0,
                  widthModifier: selectedValue.widthModifier ?? 0,
                  longitudeModifier: selectedValue.longitudeModifier ?? 0,
                  stock: selectedValue.stock ?? 0,
                  extraDeliveryTime: selectedValue.extraDeliveryTime ?? 0,
              };
          }
      })
  };
};


// Calculate totals for the custom variant
export const calculateCustomProductTotals = (updatedCustomVariant, baseProduct) => {
  return updatedCustomVariant.characteristics.reduce((totals, c) => {
      return {
          price: totals.price + (c.extraPrice || 0),
          weight: totals.weight + (c.weightModifier || 0),
          height: totals.height + (c.heightModifier || 0),
          width: totals.width + (c.widthModifier || 0),
          longitude: totals.longitude + (c.longitudeModifier || 0),
      };
  }, { 
      price: Number(baseProduct.price) || 0, 
      weight: Number(baseProduct.weight) || 0, 
      height: Number(baseProduct.height) || 0, 
      width: Number(baseProduct.width) || 0, 
      longitude: Number(baseProduct.longitude) || 0 
  });
};


// Recalculate the custom product
export const recalculateCustomProduct = ({updatedCustomProduct, updatedCharacteristicListData, baseProduct, priceMatrixMap, selectedMap}) => {
  // console.log("Recalculating custom product", updatedCustomProduct, updatedCharacteristicListData, baseProduct, priceMatrixMap, selectedMap);

  // console.log("SETTING BASE PRICES TO characteristicListData");
  updatedCharacteristicListData = setBasePrices({
    characteristics: updatedCharacteristicListData, 
    updatedCustomProduct, 
    priceMatrixMap
  });
  // console.log("UPDATED CHARACTERISTIC LIST BASE PRICES", updatedCharacteristicListData);

  // console.log("CHECKING APPLIED DEPENDENCY RULES");
  updatedCharacteristicListData = setAppliedDependencyRules({
    characteristics: updatedCharacteristicListData, 
    dependencyRules: baseProduct.dependencyRules, 
    currCustomVariant: updatedCustomProduct, 
    priceMatrixMap, 
    selectedMap
  });
  // console.log("RULE APPLIED CHARACTERISTICS", updatedCharacteristicListData);

  // console.log("SETTING NEW PRICES TO updatedCustomProduct", updatedCustomProduct);
  updatedCustomProduct = setCustomBasePrices({
    characteristics: updatedCharacteristicListData, 
    variant: updatedCustomProduct, 
    priceMatrixMap
  });
  // console.log("UPDATED CUSTOM PRODUCT WITH NEW PRICES", updatedCustomProduct);

  return {
    updatedCustomProduct,
    updatedCharacteristicListData
  };
}